import {IntermediatePart} from "../../intermediatePart";
import CountertopGroup from "../../parts/countertopGroup";
import Cabinet from "../../parts/cabinet";

export default class Decor2 extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'decor_2';
    this.partName = 'Decor2';
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Sink"]) {
      dbFeature.metaData["Sink"] = ["All"]
    }
    return super.load_(dbFeature, new Decor2());
  }

  setLayers(layout) {

    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    const bottomCabinet = cabinetParent && cabinetParent.bottomCabinet;
    if (bottomCabinet && (bottomCabinet.disabled || !bottomCabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    const countertopGroup = this.getParent().layout.parts[CountertopGroup.id];
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    },{
      propName: 'Sink',
      propValue: (countertopGroup && countertopGroup.sink && countertopGroup.sink.disabled) ? 'None' : 'All'
    }];
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Globals.Decor2;
    }
  }
}